(ns dashboard.views.workbook-workspace.components.context-menu
  (:require ["react" :as react]
            [reagent.core :as r]
            [re-frame.core :as rf]
            [dashboard.components.popup-menu :as popup-menu]
            [dashboard.views.workbook-workspace.events :as events]
            [dashboard.views.workbook-workspace.components.common :as components]
            [dashboard.views.workbook-workspace.subs :as subs]))

(defn action-menu []
 (let [{:keys [selected-rows]} @(rf/subscribe [::subs/workbook-workspace.grid])]
   [:f> popup-menu/popup-menu
    {:trigger-class [:button :is-primary :is-small]
     :trigger-content [:div "Actions" [:span.icon.is-small>i.fas.fa-solid.fa-angle-down]]
     :disabled (empty? selected-rows)
     :content [:div.content.has-background-white
               [:a.panel-block {:on-click (fn []
                                            (rf/dispatch
                                             [::events/workbook-workspace.active-sheet.add-question-rows
                                              selected-rows])
                                            (rf/dispatch [::events/workbook-workspace.grid.clear-selection]))}
                "set as question row"]
               [:a.panel-block {:on-click (fn []
                                            (rf/dispatch
                                             [::events/workbook-workspace.active-sheet.remove-question-rows
                                              selected-rows])
                                            (rf/dispatch [::events/workbook-workspace.grid.clear-selection]))}
                "unset as question row"]
               [:a.panel-block
                {:on-click (fn []
                             (rf/dispatch
                              [::events/workbook-workspace.active-sheet.hide-rows
                               selected-rows])
                             (rf/dispatch [::events/workbook-workspace.grid.clear-selection]))}
                "hide selection"]
               [:a.panel-block
                {:on-click (fn []
                             (rf/dispatch
                              [::events/workbook-workspace.active-sheet.unhide-rows
                               selected-rows])
                             (rf/dispatch [::events/workbook-workspace.grid.clear-selection]))}
                "unhide selection"]]}]))

(defn context-menu []
  (let [X                          (r/atom false)
        Y                          (r/atom false)
        on-mouse-move              (fn [e]
                                     (swap! X + (.-movementX e))
                                     (swap! Y + (.-movementY e)))
        {initial-x   :screen-x
         initial-y   :screen-y
         is-visible? :is-visible?} @(rf/subscribe [::subs/workbook-workspace.context-menu])
        {:keys [selected-rows]}    @(rf/subscribe [::subs/workbook-workspace.grid])
        wrap-click-fn              (fn [on-click]
                                     (on-click)
                                     (rf/dispatch [::events/workbook-workspace.context-menu.close])
                                     (rf/dispatch [::events/workbook-workspace.grid.clear-selection]))]
    (react/useEffect (fn []
                       ;; Set the initial location only when
                       ;; initial-x and initial-y change.
                       ;; Should happen only on new context menu click.
                       (reset! X initial-x)
                       (reset! Y initial-y)
                       (fn []
                         ;; Clear the event listener just in case on clean up
                         ;; in general this should be already dealt with before
                         ;; this happens.
                         (.removeEventListener (.-body js/document)
                                               "mousemove"
                                               on-mouse-move)))
                     (clj->js [initial-x initial-y]))

    [:f> (fn []
           (when (and is-visible? @X @Y)
             [:div.panel.p-0  {:style {:border-radius "5px"
                                       :border        "1px solid #B6B6B4"
                                       :padding       "1rem"
                                       :position      "absolute"
                                       :top           @Y
                                       :left          @X
                                       :min-width     "200px"
                                       :overflow      "hidden"}}
              [:div.panel-heading.level.has-background-primary.has-text-white.p-1.px-3.m-0
               {:on-mouse-down (fn [] (.addEventListener (.-body js/document)
                                                         "mousemove"
                                                         on-mouse-move))
                :on-mouse-up   (fn [] (.removeEventListener (.-body js/document)
                                                            "mousemove"
                                                            on-mouse-move))}
               [:div.level-item.level-left ""]
               [:div.level-item.level-right
                [components/close-icon
                 {:on-click #(rf/dispatch [::events/workbook-workspace.context-menu.close])}]]]
              [:div.content.has-background-white
               [:a.panel-block {:on-click #(wrap-click-fn
                                            (fn []
                                              (rf/dispatch
                                               [::events/workbook-workspace.active-sheet.add-question-rows
                                                selected-rows])))}
                "set as question row"]
               [:a.panel-block {:on-click #(wrap-click-fn
                                            (fn []
                                              (rf/dispatch
                                               [::events/workbook-workspace.active-sheet.remove-question-rows
                                                selected-rows])))}
                "unset as question row"]
               [:a.panel-block
                {:on-click #(wrap-click-fn
                             (fn []
                               (rf/dispatch
                                [::events/workbook-workspace.active-sheet.hide-rows
                                 selected-rows])))}
                "hide selection"]
               [:a.panel-block
                {:on-click #(wrap-click-fn
                             (fn []
                               (rf/dispatch
                                [::events/workbook-workspace.active-sheet.unhide-rows
                                 selected-rows])))}
                "unhide selection"]]]))]))
